(function ($, njm) {
    'use strict';

    njm.views.stickyButton = Backbone.View.extend({

        initialize: function () {
			var $this = this;
			
			if (!window.stickyButton) {
				window.stickyButton = {};
			}
			
			//check window object for an override jQuery object that defines the element after which to display the sticky button
			//if none set, set it to the known hero banner element classes
			this.targetEl = window.stickyButton.element ? window.stickyButton.element.eq(0) : $('.comp-inner-banner-quote, .comp-banner, .comp-banner-quote').eq(0);
			
			this.offsetHeight = false;
			
			if (this.targetEl.length > 0) {
				
				this.handleScroll();
			
				window.onscroll = function(){
					$this.handleScroll();
				}

				window.onresize = function() {
					$this.handleScroll();
				}
			}
			
			
        },
		
		measureOffsetHeight: function() {
			this.offsetHeight = this.targetEl[0].clientHeight + this.targetEl.offset().top;
		},
		
		displayBtn: function() {
			this.$el.addClass('active');
			this.$el.find('> .container > .button').attr('tabindex', "0");
		},

		hideBtn: function() {
			this.$el.removeClass('active');
			this.$el.find('> .container > .button').attr('tabindex', "-1");
		},
		
		handleScroll: function() {
			this.measureOffsetHeight();
			
			if (window.pageYOffset > this.offsetHeight) {
				this.displayBtn();
			} else {
				this.hideBtn();
			}
		}

       
    })
})(jQuery, njm);